// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Dashboard_wrapper__3GXKJ","pageTitle":"Dashboard_pageTitle__1gb91","actionCard":"Dashboard_actionCard__3aaGY"};